import axios, { AxiosError } from 'axios';

/**
 * APIエラーを処理し、適切なエラーメッセージを返す
 * @param error 発生したエラー
 * @param defaultMessage デフォルトのエラーメッセージ
 * @returns 適切なエラーメッセージを含むエラーオブジェクト
 */
export const handleApiError = (error: unknown, defaultMessage: string = '処理中にエラーが発生しました'): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<any>;
    
    // サーバーからのエラーメッセージがある場合はそれを使用
    if (axiosError.response?.data?.message) {
      return new Error(axiosError.response.data.message);
    }
    
    // バリデーションエラーの場合
    if (axiosError.response?.data?.errors) {
      const errors = axiosError.response.data.errors;
      const errorMessages = Object.values(errors).flat() as string[];
      return new Error(errorMessages.join('\n'));
    }
    
    // ステータスコードに基づくメッセージ
    if (axiosError.response) {
      switch (axiosError.response.status) {
        case 401:
          return new Error('認証エラー：再度ログインしてください');
        case 403:
          return new Error('権限がありません');
        case 404:
          return new Error('リソースが見つかりません');
        case 422:
          return new Error('入力内容に誤りがあります');
        case 429:
          return new Error('リクエスト回数が多すぎます。しばらく待ってから再試行してください');
        case 500:
          return new Error('サーバーエラーが発生しました');
        default:
          return new Error(`エラーが発生しました（ステータスコード: ${axiosError.response.status}）`);
      }
    }
    
    // ネットワークエラー
    if (axiosError.request && !axiosError.response) {
      return new Error('ネットワークエラー：サーバーに接続できません');
    }
  }
  
  // その他のエラー
  if (error instanceof Error) {
    return error;
  }
  
  // デフォルトエラー
  return new Error(defaultMessage);
};
